
<template lang='pug'>
  el-dialog(:title="'checklist 第'+(parseInt(item.row)+1)+'行'", :visible.sync="visible")
    div(v-for="(v, k) in cl_content")
      div
        b {{k}}
        div(v-for="(val, key) in cl_content[k]")
          el-checkbox( v-model="cl_content[k][key]") {{key}}
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  props: {
    tableName: String
  },
  data: function() {
    return {
      visible: false,
      item: {},
      ready: false,
      cl_content: {}
    };
  },
  methods: {
    show: function(item) {
      var progresses_default;
      this.item = item;
      if (this.item.cl_content) {
        this.cl_content = this.item.cl_content;
        this.visible = true;
        return;
      }
      if (this.tableName === 'projects') {
        if (!item['职能模块']) {
          this.$message("请先选择职能模块");
          return false;
        }
        return app.api.find({
          tableName: 'categories',
          query: {
            '名称': item['职能模块']
          }
        }).then((cats) => {
          var cat, cat_arr, projects_default;
          if (cats.length === 0) {
            this.$message("请先选择职能模块");
            return false;
          }
          cat = cats[0]['负责人'];
          cat_arr = cat.split(';');
          if (cat_arr.includes(this.item['项目经理'])) {
            projects_default = {
              '步骤1:搜寻阶段': {
                '步骤1-1:当天-“一键匹配”沟通': false,
                '步骤1-2:当天-首批人选推荐（负责板块）': false,
                '步骤1-3:“猎聘”、SL有简历人选沟通': false
              },
              '步骤2:面试阶段': {
                '步骤2-1:时间地点重点确认': false,
                '步骤2-2:面试反馈上传': false
              },
              '步骤3:Offer及离职阶段': {
                '步骤3-1:书面offer截屏/照片': false,
                '步骤3-2:offer确认邮件截屏': false,
                '步骤3-3:离职申请邮件截屏': false,
                '步骤3-4:离职确认函拍照/时间截屏': false,
                '步骤3-5:到岗确认（合同签订）': false
              }
            };
          } else {
            projects_default = {
              '步骤1:搜寻阶段': {
                '步骤1-1:当天-“一键匹配”沟通': false,
                '步骤1-2:当天-SL数据库建立，资源整合': false,
                '步骤1-3:当天-猎聘搜索沟通、已有简历相关人选': false,
                '步骤1-4:三天内-首批人选推荐（新板块）': false
              },
              '步骤2:面试阶段': {
                '步骤2-1:时间地点重点确认': false,
                '步骤2-2:面试反馈上传': false
              },
              '步骤3:Offer及离职阶段': {
                '步骤3-1:书面offer截屏/照片': false,
                '步骤3-2:offer确认邮件截屏': false,
                '步骤3-3:离职申请邮件截屏': false,
                '步骤3-4:离职确认函拍照/时间截屏': false,
                '步骤3-5:到岗确认（合同签订）': false
              }
            };
          }
          this.cl_content = projects_default;
          return this.visible = true;
        });
      } else if (this.tableName === 'progresses') {
        progresses_default = {
          '步骤1:推荐阶段': {
            '步骤1-1:获得简历': false,
            '步骤1-2:推荐至客户经理': false,
            '步骤1-3:推荐至客户方': false
          },
          '步骤2:面试阶段': {
            '步骤2-1:一面面试反馈': false,
            '步骤2-2:二面面试反馈': false,
            '步骤2-3:谈薪': false
          },
          '步骤3:Offer阶段': {
            '步骤3-1:口头接受offer': false,
            '步骤3-2:书面签订offer': false
          },
          '步骤4:离职管理': {
            '步骤4-1:候选人提出离职（离职申请邮件截屏）': false,
            '步骤4-2:离职确认函': false,
            '步骤4-3:到岗入职': false,
            '步骤4-4:通过试用期': false,
            '步骤4-5:开付费发票': false
          }
        };
        this.cl_content = progresses_default;
        return this.visible = true;
      }
    },
    hide: function() {
      return this.visible = false;
    }
  },
  watch: {
    cl_content: {
      handler: function(val, oldVal) {
        var checklist, child_finished, child_total, content, finished, k, key, total, v;
        finished = 0;
        content = val;
        total = 0;
        if (content) {
          for (k in content) {
            v = content[k];
            total++;
            child_finished = 0;
            child_total = 0;
            for (key in v) {
              val = v[key];
              child_total++;
              if (val) {
                child_finished++;
              }
            }
            if (child_finished === child_total) {
              finished++;
            }
          }
          checklist = finished + '/' + total;
          return app.api.update({
            tableName: this.tableName,
            _id: this.item._id,
            data: {
              cl_content: content,
              checklist: checklist,
              html: {
                cl_content: null
              }
            }
          }).then(() => {
            return this.item.checklist = checklist;
          });
        }
      },
      deep: true
    }
  }
};
</script>

